import { render, staticRenderFns } from "./Venues.vue?vue&type=template&id=4ab4aed7"
import script from "./Venues.vue?vue&type=script&lang=js"
export * from "./Venues.vue?vue&type=script&lang=js"
import style0 from "./Venues.vue?vue&type=style&index=0&id=4ab4aed7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports